<template>
    <v-layout row justify-center v-if="visible">
        <v-card elevation="0" style="max-width: 600px;">
            <v-card-title>
                <h3>{{ $t("horizontalSaw") }}</h3>
            </v-card-title>
            <v-card-text>
                 <v-layout wrap>
                    <v-flex xs12 sm4 pa-2>
                        <v-layout wrap>
                            <v-flex xs12 sm12 pa-2>
                                <v-text-field
                                    :label="`${$t('maxSawsAmount')}`"
                                    :hint="$t('maxSawsAmount')"
                                    :rules="[rules.required, rules.maxAmount]"
                                    v-model="maxAmount.val"
                                    @change="changeHandler"
                                    ref="maxSaws"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 pa-2>
                                <v-text-field
                                    :label="$t('kerf')"
                                    :hint="`${$t('kerf')}, ${$t('mm')}`"
                                    :suffix="$t('mm')"
                                    :rules="[rules.required, rules.kerf]"
                                    v-model="kerf.val"
                                    @change="changeHandler"
                                    ref="kerf"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                 </v-layout>
            </v-card-text>
        </v-card>
    </v-layout>
</template>

<script>
    export default {
        name: "HorizontalSawSettings",

        data () {
            return {
                changed: false,
                checkingInput: false,
                disableWatch: false,
                maxAmount: { val: 0, min: 0, max: 0 },
                kerf: { val: 0, min: 0, max: 0 },
                rules: {
                    required:  value => !!value || this.$t("requiredField"),
                    maxAmount: value => (value >= this.maxAmount.min && value <= this.maxAmount.max) || this.$t("incorrectValue"),
                    kerf:      value => (value >= this.kerf.min && value <= this.kerf.max) || this.$t("incorrectValue")
                },
                visible: false
            }
        },

        watch: {
            visible: function (val) { this.changed = val ? false : this.changed; }
        },

        methods: {
            changeHandler () {
                if (!this.disableWatch) { this.changed = true; }
            }
        }
    }
</script>
